import { createContext, useContext, useEffect, useState } from 'react';

import {
  fetchMediums,
  fetchClassTypes,
  fetchDistrictCities,
  fetchEduLevelSubjects,
} from '../services/masterData.service';
import { AuthContext } from './AuthContext';

const MasterDataContext = createContext();

const mapToOptions = (data) =>
  data
    .map((item) => ({
      name: item.name,
      id: item.id,
    }));

export const MasterDataProvider = ({ children }) => {
  const { authLoading } = useContext(AuthContext);
  const [masterData, setMasterData] = useState({
    subjectOptions: [],
    mediumOptions: [],
    cityOptions: [],
    classTypeOptions: [],
    loading: true,
  });

  useEffect(() => {
    if (authLoading) return;
    const load = async () => {
      try {
        const [subjectsRes, mediumsRes, citiesRes, classTypesRes] = await Promise.all([
          fetchEduLevelSubjects(),
          fetchMediums(),
          fetchDistrictCities(),
          fetchClassTypes(),
        ]);

        setMasterData({
          subjectOptions: mapToOptions(subjectsRes.data),
          mediumOptions: mapToOptions(mediumsRes.data),
          cityOptions: mapToOptions(citiesRes.data),
          classTypeOptions: mapToOptions(classTypesRes.data),
          loading: false,
        });
      } catch (error) {
        console.error(error);
      }
    };

    load();
  }, [authLoading]);

  return <MasterDataContext.Provider value={masterData}>{children}</MasterDataContext.Provider>;
};

export const useMasterData = () => useContext(MasterDataContext);
